/**
 * Sanitizes a string to be safe for use in filenames
 */
export const sanitizeForFilename = (str: string): string => {
  if (!str) return '';

  return str
    .replace(/[^a-zA-Z0-9\s-_]/g, '')
    .replace(/\s+/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_|_$/g, '');
};

interface GenerateFilenameParams {
  organizationName: string;
  category: string;
  trustRegNumber?: string;
  surveyNumber?: string;
  propertyName?: string;
}

/**
 * Generates export filenames.
 *
 * Examples:
 * Org_Charitable_Registrations.xlsx
 * Org_Charitable_TRUST123_Lands.xlsx
 * Org_Charitable_TRUST123_SURVEY45_Properties.xlsx
 * Org_Charitable_TRUST123_SURVEY45_HouseA_SubProperties.xlsx
 */
export const generateFilename = ({
  organizationName,
  category,
  trustRegNumber,
  surveyNumber,
  propertyName,
}: GenerateFilenameParams): string => {
  const parts = [
    sanitizeForFilename(organizationName),
    sanitizeForFilename(category),
    sanitizeForFilename(trustRegNumber || ''),
    sanitizeForFilename(surveyNumber || ''),
    sanitizeForFilename(propertyName || ''),
  ].filter(Boolean);

  let suffix = 'registrations';

  if (trustRegNumber) suffix = 'lands';
  if (surveyNumber) suffix = 'properties';
  if (propertyName) suffix = 'subproperties';

  return `${parts.join('_')}_${suffix}.xlsx`;
};
